'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input-number/style/css');

var _inputNumber = require('antd/lib/input-number');

var _inputNumber2 = _interopRequireDefault(_inputNumber);

var _css2 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 退款按钮及弹出表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var OrderRefund = _react2.default.createClass({
    displayName: 'OrderRefund',

    propTypes: {
        order: _react.PropTypes.object.isRequired,
        form: _react.PropTypes.object.isRequired
    },
    onOk: function onOk(form) {
        this.props.onSubmit(form.getFieldsValue());
    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        var payment = parseInt(order.total_fee); // 实付金额
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u8BA2\u5355\u9000\u6B3E' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { required: true, label: '\u9000\u6B3E\u91D1\u989D', extra: '\u6700\u9AD8\u53EF\u9000' + payment.toFixed(2) }),
                    getFieldDecorator('fee', {})(_react2.default.createElement(_inputNumber2.default, { min: 0, max: payment.toFixed(2) }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(OrderRefund);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_refund.js
// module id = 1313
// module chunks = 0